import { Pipe, PipeTransform } from '@angular/core';
import { List, last } from 'lodash';

@Pipe({
  name: 'last',
  standalone: true,
})
export class LastPipe implements PipeTransform {
  transform<T>(value: List<T>): T | undefined {
    return last(value);
  }
}
